import React from 'react'
import Link from 'gatsby-link'

const IndexPage = () => (
  <div className='Hero'>
    <div className='HeroGroup'>
    <p>Welcome to</p>
    <h1>AI Gender Bias<br></br>Education Program</h1>
    <Link to="/0-introduction/">Instructions</Link>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js